import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Popover, Progress, Spin, Tooltip } from 'antd';
import { LineChartOutlined, InfoCircleOutlined } from '@ant-design/icons';
import responseRate from '../../Actions/responseRate';

const { getServiceResponseRate } = responseRate.actions;

class ServiceResponseRate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false
        };
    }

    componentDidMount() {
        this.props.getServiceResponseRate();
        this.interval = setInterval(() => this.props.getServiceResponseRate(), 300000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    getStatusColor(percentage) {
        if (percentage >= 90) return '#52c41a';
        if (percentage >= 70) return '#faad14';
        return '#ff4d4f';
    }

    getStatusLabel(percentage) {
        if (percentage >= 90) return 'Excelente';
        if (percentage >= 70) return 'Regular';
        return 'Bajo';
    }

    formatDate(dateString) {
        if (!dateString) return '';
        const date = new Date(dateString);
        const options = { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' };
        return date.toLocaleDateString('es-MX', options);
    }

    renderContent() {
        const { responseRateData, isLoading } = this.props;

        if (isLoading) {
            return (
                <div className="response-rate-loading">
                    <Spin size="small" />
                    <span>Cargando...</span>
                </div>
            );
        }

        if (!responseRateData || !responseRateData.data) {
            return (
                <div className="response-rate-empty">
                    <span>Sin datos disponibles</span>
                </div>
            );
        }

        const { dateFrom, dateTo, data } = responseRateData;
        const wsData = data.find(d => d.requestType === 'WS') || { answeredPercentage: 0 };
        const portalData = data.find(d => d.requestType === 'Portal|Scraping') || { answeredPercentage: 0 };

        return (
            <div className="response-rate-content">
                <div className="response-rate-header">
                    <div className="response-rate-title-row">
                        <span className="response-rate-title">Tasa de Respuesta</span>
                        <Tooltip 
                            title="Porcentaje de solicitudes de descarga completadas en los últimos 7 días naturales. Indica la disponibilidad y rendimiento del servicio del SAT."
                            placement="bottom"
                        >
                            <InfoCircleOutlined className="response-rate-info" />
                        </Tooltip>
                    </div>
                    <span className="response-rate-period">
                        {this.formatDate(dateFrom)} - {this.formatDate(dateTo)}
                    </span>
                </div>
                
                <div className="response-rate-cards">
                    <div className="response-rate-card">
                        <div className="card-title">Web Service</div>
                        <div className="card-progress">
                            <Progress 
                                type="circle" 
                                percent={wsData.answeredPercentage} 
                                width={70}
                                strokeColor={this.getStatusColor(wsData.answeredPercentage)}
                                format={percent => `${percent}%`}
                            />
                        </div>
                        <div 
                            className="card-status" 
                            style={{ color: this.getStatusColor(wsData.answeredPercentage) }}
                        >
                            {this.getStatusLabel(wsData.answeredPercentage)}
                        </div>
                    </div>

                    <div className="response-rate-card">
                        <div className="card-title">Portal SAT</div>
                        <div className="card-progress">
                            <Progress 
                                type="circle" 
                                percent={portalData.answeredPercentage} 
                                width={70}
                                strokeColor={this.getStatusColor(portalData.answeredPercentage)}
                                format={percent => `${percent}%`}
                            />
                        </div>
                        <div 
                            className="card-status" 
                            style={{ color: this.getStatusColor(portalData.answeredPercentage) }}
                        >
                            {this.getStatusLabel(portalData.answeredPercentage)}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <Popover
                content={this.renderContent()}
                trigger="hover"
                placement="bottomRight"
                overlayClassName="response-rate-popover"
            >
                <span className="header-option response-rate-trigger">
                    <LineChartOutlined className="response-rate-icon" />
                    <span className="response-rate-label">Tasa de descarga</span>
                </span>
            </Popover>
        );
    }
}

const mapStateToProps = state => {
    return {
        responseRateData: state.responseRate.responseRateData,
        isLoading: state.responseRate.isLoading,
        error: state.responseRate.error
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getServiceResponseRate() {
            dispatch(getServiceResponseRate());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ServiceResponseRate);

